import React from 'react'
import GetInventoryOrderButton from '../../Orders/OrderItem/GetInventoryOrderButton'
import { downloadInvoicePDFMgr } from '../../../Reducers/balance'
import './styles.scss'
import { EllipsisOutlined } from '@ant-design/icons'
import { Button, Modal } from 'antd'
import useBoolean from '../../../Utils/useBoolean'

const PrintOrdersLinks = ({ orders }) => {

  const { value: isOpen, setFalse: close, setTrue: open } = useBoolean(false);

  const ordersLength = orders.length
  
  return (
    <div className="orders_buttons">
      {ordersLength <= 5 ? 
      orders?.map((id) => (
        <GetInventoryOrderButton orderId={id} getInventoryOrder={downloadInvoicePDFMgr} title={id} />
      ))
      :
      <div className="orders_buttons">
      {orders?.slice(0,5).map((id) => (
        <GetInventoryOrderButton orderId={id} getInventoryOrder={downloadInvoicePDFMgr} title={id} />
      ))}
      <Button size="small" type="primary" onClick={open} icon={<EllipsisOutlined />}/>
      <Modal
      // visible={visible}
      open={isOpen}
      closable={false}
      maskClosable={false}
      title="Orders download"
      footer={[
        <Button key="back" onClick={close}>
          Return
        </Button>
      ]}
        >
          <div className="orders_buttons">
          {orders?.map((id) => (
            <GetInventoryOrderButton orderId={id} getInventoryOrder={downloadInvoicePDFMgr} title={id} />
          ))}
          </div>
        </Modal>
      </div>
    }
    </div>
  )
}

export default PrintOrdersLinks
